// extracted by mini-css-extract-plugin
export default {"iconFillColor":"IconFillColor_iconFillColor__uymCG"};